// extracted by mini-css-extract-plugin
export default {"flip":"Hovers_flip__wrsVF","flip__side":"Hovers_flip__side__C5E9X","flip__side__back":"Hovers_flip__side__back__KNu-K","flip__side__front":"Hovers_flip__side__front__3hTbs"};